export function wheelDeltaToPixels(
  delta: number,
  deltaMode: number,
  pageSize: number
) {
  if (deltaMode === 1) {
    return delta * 16;
  }
  if (deltaMode === 2) {
    return delta * pageSize;
  }
  return delta;
}

export function handleTableWheel(event: WheelEvent) {
  if (event.metaKey || event.ctrlKey) {
    return;
  }

  const xScrollContainer = event.currentTarget;
  if (!(xScrollContainer instanceof HTMLElement)) {
    return;
  }

  const yScrollContainer = xScrollContainer.parentElement;
  const canScrollX =
    xScrollContainer.scrollWidth > xScrollContainer.clientWidth;
  const canScrollY =
    yScrollContainer &&
    yScrollContainer.scrollHeight > yScrollContainer.clientHeight;

  if (!canScrollX) {
    return;
  }

  const rawDeltaX = event.deltaX;
  const rawDeltaY = event.deltaY;
  const deltaX =
    event.shiftKey && Math.abs(rawDeltaY) > Math.abs(rawDeltaX)
      ? rawDeltaY
      : rawDeltaX;
  const deltaY = event.shiftKey ? 0 : rawDeltaY;
  const horizontal = Math.abs(deltaX) > Math.abs(deltaY);

  if (!horizontal && canScrollY) {
    yScrollContainer.scrollTop += wheelDeltaToPixels(
      deltaY,
      event.deltaMode,
      yScrollContainer.clientHeight
    );
    event.preventDefault();
    event.stopPropagation();
    return;
  }

  if (!horizontal) {
    return;
  }

  const maxScrollLeft =
    xScrollContainer.scrollWidth - xScrollContainer.clientWidth;
  const nextScrollLeft = Math.max(
    0,
    Math.min(
      maxScrollLeft,
      xScrollContainer.scrollLeft +
        wheelDeltaToPixels(
          deltaX,
          event.deltaMode,
          xScrollContainer.clientWidth
        )
    )
  );
  xScrollContainer.scrollLeft = nextScrollLeft;
  event.preventDefault();
  event.stopPropagation();
}
